<template>
    <div class="yq-portal" v-if="portal" v-route-title="portal.name">
        <div class="yq-portal-left">
            <div class="yq-portal-left-head">
                <div class="yq-portal-title">{{portal.name}}</div>
                <el-input class="yq-portal-tree-filter" v-model="treeFilter" size="mini" :placeholder="treeFilterPlaceholder"
                          prefix-icon="el-icon-search" @focus="treeFilterPlaceholder='请输入'"
                          @blur="treeFilterPlaceholder='快速查找'"></el-input>
            </div>
            <div v-if="pages">
                <el-tree ref="tree" node-key="id" :current-node-key="currentPage?currentPage.data.id:null" highlight-current
                         class="yq-portal-tree" :data="pages" :props="treeProps" default-expand-all
                         @current-change="onCurrentChange" :filter-node-method="filterNode">
                <span class="yq-portal-tree-node" slot-scope="{ node, data }">
                    <span class="yq-portal-tree-node-left">
                        <i :class="{
                        'el-icon-folder-opened': data.type==='folder' && node.expanded,
                        'el-icon-folder': data.type==='folder' && !node.expanded,
                        'el-icon-tickets': data.type!=='folder'
                        }"></i>
                        <span>{{ node.label }}</span>
                    </span>
                </span>
                </el-tree>
            </div>
        </div>
        <div class="yq-portal-center">
            <component v-if="currentPage" ref="page" :is="currentPage.type.component"
                       :id="currentPage.data.id" :is-template="false"></component>
        </div>
    </div>
</template>

<script>
    import portalService from '../service/portal'
    import pageService from '../service/page'
    import pageTypeService from '../service/page-type'

    export default {
        name: "Portal",
        props: ['id'],
        data(){
            return {
                portal: null,
                treeFilter: null,
                treeFilterPlaceholder: '快速查找',
                pages: null,
                treeProps: {
                    children: 'children',
                    label: 'name'
                },
                currentPage: null
            }
        },
        created(){
            this.init()
        },
        watch: {
            id(){
                this.init()
            },
            treeFilter(val){
                this.$refs.tree.filter(val);
            }
        },
        methods: {
            init(){
                portalService.getPortal(this.id).then(response=>{
                    this.portal = response.data
                    pageService.listPages({
                        portalId: this.id,
                        page: 0,
                        size: 1000
                    }).then(response => {
                        const pages = response.data.content
                        this.pages = portalService.buildPortalPageTree(pages)
                        this.currentPage = null
                        const stack= [...this.pages]
                        while(stack.length>0){
                            const page = stack.shift()
                            if(page.type !== 'folder'){
                                this.currentPage = {
                                    data: page,
                                    type: pageTypeService.getPageType(page.type)
                                }
                                break
                            }
                            if(page.children){
                                stack.splice(0,0,...page.children)
                            }
                        }
                    })
                }).catch(()=>{
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            },
            async onCurrentChange(data){
                if(data.type === 'folder'){
                    return
                }
                if(this.currentPage && this.currentPage.data === data){
                    return
                }
                this.currentPage = {
                    data: data,
                    type: pageTypeService.getPageType(data.type)
                }
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            }
        }
    }
</script>

<style scoped>
</style>
